import { FormKeyMap as PrimaryFormKeyMap } from '../components/PrimaryAuthFormArea/constant';
import { FormKeyMap as SeniorFormKeyMap } from '../components/SeniorAuthFormArea/constant';

export { BusinessType } from '../components/PrimaryAuthFormArea/constant';

export const FormKeyMap = {
  ...PrimaryFormKeyMap,
  ...SeniorFormKeyMap,
};
